import React from 'react'
import { createUseStyles } from 'react-jss'
import Carousel from 'react-multi-carousel'
import SVG from '../ui/SVG/SVG'
import { isClientSide } from '../ui/Common/utils'
import obj2Arr from '../../utils/obj2Arr'

const useStyles = createUseStyles(theme => ({
  wrapperS: {
    boxSizing: 'border-box',
    backgroundColor: '#F0F8FF',
    padding: '140px 0',
    '@media (max-width: 700px)': {
      padding: '70px 0',
    },
  },
  containerS: {
    padding: '0',
    margin: '0 auto',
    width: '100%',
    maxWidth: '1220px',
    '@media (max-width: 1200px)': {
      boxSizing: 'border-box',
      padding: '0 15px',
    },
    '@media (max-width: 700px)': {
      boxSizing: 'border-box',
      padding: '0 15px',
    },
  },
  titleS: {
    fontFamily: 'TTRounds',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '38px',
    lineHeight: '41px',
    textAlign: 'center',
    color: '#2D2D2D',
    marginBottom: '40px',
    '@media (max-width: 700px)': {
      marginBottom: '25px',
    },
  },
  bodyS: {
    fontFamily: 'Avenir Next',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '20px',
    lineHeight: '27px',
    textAlign: 'center',
    color: '#2D2D2D',
    marginBottom: '85px',
    '@media (max-width: 700px)': {
      marginBottom: '55px',
    },
  },
  itemsListItem: {
    marginBottom: '85px',
    '&:last-child': {
      marginBottom: '0px',
    },
    '@media (max-width: 700px)': {
      marginBottom: '55px',
      '&:last-child': {
        marginBottom: '0px',
      },
    },
  },
  itemsListItemTitle: {
    fontFamily: 'TTRounds',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '26px',
    lineHeight: '30px',
    textAlign: 'center',
    color: '#007AC3',
    marginBottom: '15px',
  },
  itemsListItemImg: {
    width: '185px',
    height: 'auto',
    verticalAlign: 'bottom',
  },
  itemsListItemImgTitle: {
    fontFamily: 'Avenir Next',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '20px',
    lineHeight: '27px',
    textAlign: 'center',
    color: '#2D2D2D',
    paddingTop: '24px',
    '@media (max-width: 700px)': {
      paddingTop: '12px',
    },
  },
  itemsListItemImgs: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  itemsListItemImgWrapper: {
    padding: '10px',
    boxSizing: 'border-box',
    width: '205px',
  },
}))

const Signages = props => {
  const classes = useStyles()

  const { title, body } = props
  const signagelists = obj2Arr(props.signagelist)

  return (
    <div className={classes.wrapperS}>
      <div className={classes.containerS}>
        <div className={classes.titleS}>{title}</div>
        {body && <div className={classes.bodyS}>{body}</div>}
        <div className={classes.itemsList}>
          {signagelists.map(({ title, signageitems }) => (
            <div className={classes.itemsListItem} key={title}>
              <div className={classes.itemsListItemTitle}>{title}</div>

              <div className={classes.itemsListItemImgs}>
                {signageitems.map(({ title, img }, index) => (
                  <div className={classes.itemsListItemImgWrapper} key={`item_imgs_${index}`}>
                    <div>
                      <img className={classes.itemsListItemImg} src={img} />
                    </div>
                    {title && <div className={classes.itemsListItemImgTitle}>{title}</div>}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Signages
